import { render, staticRenderFns } from "./DataSourceSelect.vue?vue&type=template&id=55912d34&scoped=true&"
import script from "./DataSourceSelect.vue?vue&type=script&lang=ts&"
export * from "./DataSourceSelect.vue?vue&type=script&lang=ts&"
import style0 from "./DataSourceSelect.vue?vue&type=style&index=0&id=55912d34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55912d34",
  null
  
)

export default component.exports